import { Row, Col, Divider, Table } from "antd";
import {
  DashboardOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import "./cartop.css";

import { FormattedMessage, useIntl } from "react-intl";
import useIsDesktop from "../../utils/hooks/useIsDesktop";
import Typography from "../Typography";
import { COLORS } from "../../constants/Colors";
import MyButton from "../Button";
import ActiveQueue from "./ActiveQueue";

const CardLeftHome = (props) => {
  const { data, type ,openCreateQueue} = props;
  const isDesktop = useIsDesktop();

  const columns = [
    {
      title: (
        <Typography isBold color={COLORS.Dark} size={"13px"}>
          <FormattedMessage
            id="ActiveQueueHome"
            defaultMessage="Active Queue"
          />
        </Typography>
      ),
      dataIndex: "name",
      key: "name",
      render: (text) => <a>{text}</a>,
    },
    {
      title: (
        <Typography isBold color={COLORS.Dark} size={"13px"}>
          <FormattedMessage
            id="HomeParkingQueueWaiting"
            defaultMessage="คิวที่รอส่ง"
          />
        </Typography>
      ),
      dataIndex: "age",
      key: "age",
      align: "center",
    },
    {
      title: (
        <Typography isBold color={COLORS.Dark} size={"13px"}>
          <FormattedMessage id="สถานะ" defaultMessage="HomeParkingStatus" />
        </Typography>
      ),
      dataIndex: "address",
      key: "address",
    },
  ];


  const parkingContent = (
    <div
      style={{
        borderRadius: "8px",
        backgroundColor: "white",
        width: "100%",
        height: isDesktop ? "calc(100vh - 255px)" : undefined,
      }}
    >
      <div className="d-flex flex-column justify-content-center text-left w-100">
        <Row style={{ marginTop: "0px", padding: "16px" }}>
          <Col span={12}>
            <Typography
              className="pt-3 pb-1 px-1"
              isBold
              color={COLORS.Dark}
              size={"16px"}
            >
              <FormattedMessage
                id="ActiveQueueHome"
                defaultMessage="Active Queue"
              />
            </Typography>
          </Col>
          <Col className="right-card-top" span={12}>
            <Typography className="" isBold color={COLORS.Dark} size={"16px"}>
              <MyButton style={{backgroundColor: COLORS.GreenBrown ,color: COLORS.White}} onClick={() => {openCreateQueue()}}>
                {isDesktop ?   <span>
                  <FormattedMessage
                    id="btnAddQueueButton"
                    defaultMessage="เพิ่มคิวใหม่"
                  />
                </span> : <PlusOutlined /> }
              
              </MyButton>
            </Typography>
          </Col>
        </Row>
        <Divider className="m-0" />

        <ActiveQueue data={data}/>
      </div>
    </div>
  );
  

  return parkingContent;
};

export default CardLeftHome;
